
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { NavigateFunction, useNavigate, useParams } from "react-router-dom";

import { Typography } from "@mui/material";
import NavigateListCustom from "../../../components/navigation/NavigationListCustom";
import { routeName } from "../../../routes/routeName";
import StepperCustom from "../../../components/step/Stepper";
import { useTranslation } from "react-i18next";
import MeetingDetail from "./step/meeting-detail";
import MeetingCoordinator from "./step/meeting-coordinator";
import MeetingParticipants from "./step/meeting-participants";
import AgendaInformation from "./step/agenda-information";
import { ButtonOutlined, ButtonPrimary } from "../../../components/button/ButtonCustoms";
import { MeetingRoomApi } from "../../../api/meeting-room/meeting-room.api";
import { swalError, swalSuccess } from "../../../components/alert/swal";
import { timeToView } from "../../../utils/date.utils";
import Resolution from "./step/resolution";
import ConductMeeting from "./step/conduct-meeting";


type Props = {};
const defaultStateFormMeetingRoom = {
    id_meeting_type: 0,
    meeting_room_name: undefined,
    meeting_room_desc: undefined,
    meeting_room_password: undefined,
    meeting_room_start_date: undefined,
    meeting_room_end_date: undefined,
    meeting_room_location: undefined,
    meeting_room_link: undefined,
    id_meeting_file_contents: undefined,
    id_meeting_file_agenda: undefined,
    id_meeting_file_other: undefined,
}
const StudentsMeetingCalendarDetail: React.FC<Props> = (props: Props) => {
    const { id } = useParams();

    const navigate: NavigateFunction = useNavigate();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [formMeetingRoom, setFormMeetingRoom] = useState<any>(defaultStateFormMeetingRoom)
    // const step: number = useSelector((state: any) => state?.step?.step);
    const [step, setStep] = useState<number>(0)
    const [notEdit, set์otEdit] = useState<boolean>(true)
    const allStep: any[] = useMemo(() => [
        { name: t('MEETING_CATEGORY.DETAILS'), isAccept: true, icon: null, disabled: !notEdit },
        { name: t('MEETING.MEETING_COORDINATOR'), isAccept: true, icon: null, disabled: !notEdit },
        { name: t('MEETING.MEETING_PARTICIPANTS'), isAccept: true, icon: null, disabled: !notEdit },
        { name: t('MEETING.AGENDA_INFO'), isAccept: true, icon: null, disabled: !notEdit },
        { name: t('ดำเนินการประชุม'), isAccept: true, icon: null, disabled: !notEdit },
        { name: t('MEETING.MEETING_RESOLUTIONS'), isAccept: true, icon: null, disabled: !notEdit },

    ], [t,]);

    console.log(formMeetingRoom);

    const getDetail = async () => {
        await MeetingRoomApi.findById(id).then((res: any) => {
            if (res.status < 300) {
                console.log(res.data.data);
                setFormMeetingRoom({ ...formMeetingRoom, ...res.data.data, meeting_room_start_time: timeToView(res.data.data?.meeting_room_start_date), meeting_room_end_time: timeToView(res.data.data?.meeting_room_end_date), meeting_room_password_check: res.data.data?.meeting_room_password })
                // loadData()
                // handleClose()
            }
        }).catch((error: any) => {
            console.log(error)
            swalError(error?.response?.data?.message || 'เกิดข้อผิดพลาด')
        })
    }
    useEffect(() => {
        if (id) {
            getDetail()
        }

    }, [])


    return (
        <div className="h-auto">
            {/* breadcrumbs */}
            <NavigateListCustom
                navigateData={[
                    {
                        name: "ปฏิทินการประชุม",
                        key: "1",
                        pathName: routeName.students.MeetingCalendar,
                    },
                    {
                        name: "ข้อมูลการประชุม",
                        key: "2",
                        pathName: routeName.students.MeetingCalendar,
                    },
                ]}
            />

            {/* header */}
            <section className="my-4">
                <Typography variant="h3">ข้อมูลการประชุม</Typography>
            </section>
            <section style={{
                display: "flex",
                justifyContent: "center",
            }}>
                <StepperCustom
                    sx={{ maxWidth: "900px" }}
                    step={step}
                    setStep={(num: number) => {
                        // dispatch(setStep(num));
                        setStep(num)
                    }}
                    stepLabel={allStep}
                    // view={is_accept}
                    view
                />
            </section>
            {step === 0 &&
                <section className="w-full mt-10">

                    <MeetingDetail formMeetingRoom={formMeetingRoom} setFormMeetingRoom={setFormMeetingRoom} />
                </section>
            }
            {step === 1 &&
                <MeetingCoordinator />
            }
            {step === 2 &&
                <MeetingParticipants />
            }
            {step === 3 &&
                <AgendaInformation />
            }
            {step === 4 &&
                <ConductMeeting />
            }
            {step === 5 &&
                <Resolution />
            }


            <section className="col-span-12 flex items-center justify-center gap-4 my-4">
                {step !== 5 &&
                    <ButtonOutlined
                        onClick={() => {
                            navigate(routeName.students.MeetingCalendar);
                        }}
                        buttonName="ย้อนกลับ"
                        btnProps={{
                            width: "150px",
                        }}
                    />
                }

                {/* <ButtonPrimary
                    onClick={() => {
                        // handleSubmit(inputValueFormStudent.information);
                        handleSubmitMeetingRoom()
                    }}
                    mode="save"
                    buttonName="บันทึกร่าง"
                    btnProps={{
                        width: "150px",
                    }}
                />
                <ButtonPrimary
                    onClick={() => {
                        // handleSubmit(inputValueFormStudent.information);
                    }}
                    mode="success"
                    buttonName="ถัดไป"
                    btnProps={{
                        width: "150px",
                    }}
                /> */}
            </section>
        </div>
    );
};

export default StudentsMeetingCalendarDetail;
